const UWM_COMMAND_TYPES = {
    UWM_EVENT: 'UwmEvent',
    UWM_INIT_TIPS_TUTORIALS: 'UWM_INIT_TIPS_TUTORIALS',
    UWM_INIT_MARKET_LOCALE: 'UWM_INIT_MARKET_LOCALE',
};

export default UWM_COMMAND_TYPES;
